import { AkBadgeColor, IconName } from '@ankorstore/design-system';
import { StorageTemperatureEnum } from '@monolith/legacy/types/product';

export interface TemperatureBadgeConfig {
  color: AkBadgeColor;
  symbol: IconName;
  labelKey: string;
}

const TEMPERATURE_BADGE_CONFIGS: Partial<Record<StorageTemperatureEnum, TemperatureBadgeConfig>> = {
  [StorageTemperatureEnum.Frozen]: {
    color: AkBadgeColor.Frozen,
    symbol: 'snowflake',
    labelKey: 'discovery.product.badges.frozenTemperature',
  },
  [StorageTemperatureEnum.UltraFreshStrictChilled]: {
    color: AkBadgeColor.Frozen,
    symbol: 'snowflake',
    labelKey: 'discovery.product.badges.ultraFreshStrictChilledTemperature',
  },
  [StorageTemperatureEnum.UltraFreshHighlyPerishable]: {
    color: AkBadgeColor.FrozenAlt,
    symbol: 'snowflake',
    labelKey: 'discovery.product.badges.highlyPerishableTemperature',
  },
  [StorageTemperatureEnum.Fresh]: {
    color: AkBadgeColor.FrozenAlt,
    symbol: 'snowflake',
    labelKey: 'discovery.product.badges.freshTemperature',
  },
  [StorageTemperatureEnum.Controlled]: {
    color: AkBadgeColor.GreyLight,
    symbol: 'speedo',
    labelKey: 'brand.product.badges.storageTemperature.Controlled',
  },
};

export function getTemperatureBadgeConfig(
  temperature?: string | null,
  exclude?: StorageTemperatureEnum[],
): TemperatureBadgeConfig | null {
  if (!temperature || temperature === StorageTemperatureEnum.None) {
    return null;
  }
  if (exclude?.includes(temperature as StorageTemperatureEnum)) {
    return null;
  }
  return TEMPERATURE_BADGE_CONFIGS[temperature as StorageTemperatureEnum] ?? null;
}

export function getFreshTemperatureBadgeConfig(temperature?: string | null): TemperatureBadgeConfig | null {
  return getTemperatureBadgeConfig(temperature, [StorageTemperatureEnum.Controlled]);
}

export const NEEDS_FRESH_INPUT_BADGE_CONFIG = {
  color: AkBadgeColor.FrozenAlt,
  symbol: 'snowflake' as IconName,
};

export function shouldShowNeedsFreshInput(storageTemperature?: string | null, needsFreshInput?: boolean): boolean {
  if (storageTemperature && storageTemperature !== StorageTemperatureEnum.None) {
    return false;
  }
  return needsFreshInput === true;
}
